import createEntityChangementConfig2 from '@infrastructure/entityChangement/createEntityChangementConfig2'
import queryClient from '@infrastructure/reactQuery/queryClient'

import { keys } from '../reactQuery'
import { acquiringName, name, orderName } from '../repository'

createEntityChangementConfig2({
  entity: name,
  config: [
    {
      changements: ['created', 'updated', 'deleted', 'archived'],
      listener: () => {
        queryClient.invalidateQueries(keys.lists())
      }
    }
  ],
  dependenciesConfig: [
    {
      entities: [orderName],
      changements: ['created'],
      listener: () => {
        queryClient.invalidateQueries(keys.acquiringsHistory())
      }
    },
    {
      entities: [acquiringName],
      changements: ['updated'],
      listener: () => {
        queryClient.invalidateQueries(keys.acquiringsHistory())
      }
    }
  ]
}).init()
